<div class="screen screen--split">

  <app-theme-header></app-theme-header>

  <!-- Stage 1 — mobile number entry. The page renders <app-custom-keyboard-number> itself,
       so this only provides the field; the keypad is restyled globally. -->
  <ng-container *ngIf="host.isPhoneNumberNotProvided">

    <h1 class="screen__title">{{ host.TXT_PAYMENT_TRUEMONEY_TITLE }}</h1>

    <div class="screen__stage phone-stage">
      <p class="phone-stage__subtitle">{{ host.TXT_PAYMENT_TRUEMONEY_SUBTITLE }}</p>
      <div class="phone-field">{{ host.enteredPhoneNumber }}</div>
    </div>

  </ng-container>

  <!-- Stage 2 — QR panel, same archetype as the other payment methods. -->
  <ng-container *ngIf="!host.isPhoneNumberNotProvided">

    <h1 class="screen__title">Please Proceed<br />The Payment</h1>

    <div class="screen__stage">

      <div class="panel qr-panel">

        <div class="qr-plate" *ngIf="host.OmiseTrueMoneyUrl && !host.isQrError">
          <qrcode [qrdata]="host.OmiseTrueMoneyUrl" [width]="256" [errorCorrectionLevel]="'M'" [margin]="0"></qrcode>
        </div>

        <div class="qr-plate qr-plate--error" *ngIf="host.isQrError">
          <img class="qr-plate__code" src="assets/img/maintenance.png" alt="" />
        </div>

        <ng-container *ngIf="host.OmiseTrueMoneyUrl && !host.isQrError">
          <img class="qr-panel__brand" src="assets/img/TRUEMONEY.png" alt="TrueMoney" />
          <div class="qr-panel__phone">{{ host.enteredPhoneNumber | mask: '000-000-0000' }}</div>
        </ng-container>

        <ng-container *ngIf="!host.isQrError && !host.commonService.isLoading">
          <hr class="hairline" />
          <div class="qr-panel__total">
            <span class="qr-panel__total-label">TOTAL</span>
            <span class="amount-box">{{ host.amountSum | number: ".2" }} {{ host.TXT_PAYMENT_SCAN_CURRENCY }}</span>
          </div>
        </ng-container>

        <div class="screen__notice" *ngIf="host.isQrError">
          {{ host.TXT_PAYMENT_SCAN_QR_ERROR_TITLE }}<br />{{ host.TXT_PAYMENT_SCAN_QR_ERROR_SUBTITLE }}
        </div>

      </div>

      <button type="button" class="outline-button outline-button--primary" (click)="host.onCheck()"
        *ngIf="host.OmiseTrueMoneyUrl" [disabled]="host.commonService.isLoading || host.isChecking" [hidden]="host.isQrError">
        {{ host.checkLabel }}
      </button>

    </div>

  </ng-container>

  <div class="screen__actions">
    <button type="button" class="outline-button" (click)="host.onBack()">BACK</button>
  </div>

</div>
